import { api } from '@/shared/services/api';

/**
 * Forma stocată pe `User.appearancePrefs` (JSONB) — cross-device sync pentru
 * preferințele de aspect (temă culori + tipografie). Coincide cu shape-ul
 * persist al stores-urilor Zustand corespunzătoare.
 *
 * Backend: `apps/api/src/modules/auth/auth.{controller,service}.ts`
 *   GET /auth/appearance-prefs
 *   PATCH /auth/appearance-prefs (partial update, server merge-uiește)
 */
export interface AppearancePrefsBlob {
  themePrefs?: any;
  fontPrefs?: any;
  formatPrefs?: { numberFormat: 'en-US' | 'ro-RO' };
}

export const appearancePrefsApi = {
  get: () => api.get<AppearancePrefsBlob | null>('/auth/appearance-prefs'),
  update: (body: AppearancePrefsBlob) => api.patch<AppearancePrefsBlob>('/auth/appearance-prefs', body),
};
